import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=4ebffe3a&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=4ebffe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebffe3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ebffe3a')) {
      api.createRecord('4ebffe3a', component.options)
    } else {
      api.reload('4ebffe3a', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=4ebffe3a&scoped=true&", function () {
      api.rerender('4ebffe3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/Welcome.vue"
export default component.exports